import makeStyles from "@mui/styles/makeStyles";
import { LinkProps } from "./Link.types";

export const useLinkStyles = makeStyles((theme) => ({
  root: (props: LinkProps) => ({
    position: "relative",
    outline: 0,
    cursor: "pointer",
    fontSize: props.size === "small" ? 12 : undefined,
    "&:disabled": {
      color: theme.palette.grey[500],
      textDecoration: "none",
      cursor: "default",
    },
    "&:hover": {
      color: theme.palette.primary.dark,
      textDecoration: "none",
    },
    "&:focus": {
      "&::before": {
        content: "''",
        position: "absolute",
        inset: "-4px",
        // TODO: find alternate
        // background: alpha(theme.palette.primary.main, 0.1),
        borderRadius: 8,
      },
    },
  }),
}));

export const useStyles = makeStyles(() => ({
  icon: {
    marginLeft: 4,
    verticalAlign: "top",
    fontSize: 16,
  },
}));
